import { QuestionaireType } from "../components/Questionaire/types";

export const questions: QuestionaireType = {
  questionsMain: [
    {
      displayValue: "Your Name",
      value: "",
      id: "name",
      group: "Your details",
      hint: "",
      required: true,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "Please add your name.",
    },
    {
      displayValue: "Email",
      value: "",
      id: "email",
      group: "Your details",
      hint: "",
      required: true,
      type: "email",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "Please add a valid email.",
    },
    {
      displayValue: "Phone Number",
      value: "",
      id: "number",
      group: "Your details",
      wide: true,
      hint: "",
      required: true,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "Please put a valid phone number with an area code.",
    },
    {
      displayValue: "Date of Wedding",
      value: "",
      id: "date",
      group: "The wedding",
      wide: true,
      hint: "",
      required: true,
      type: "date",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "Please put a date for the wedding.",
    },
    {
      displayValue: "Number of Guests",
      value: "",
      id: "guestCount",
      group: "The wedding",
      hint: "",
      required: true,
      type: "number",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "Please put the number of guests.",
    },
    {
      displayValue: "Wedding party size",
      value: "",
      id: "attendentCount",
      group: "The wedding",
      hint: "(Bridesmaids, groomsmen, etc.)",
      required: true,
      type: "number",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "Please add the number of people in the wedding party.",
    },
    {
      displayValue: "Ceremony Location",
      value: "",
      id: "location",
      group: "The wedding",
      wide: true,
      hint: "",
      required: true,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "Please add a ceremony location.",
    },
    {
      displayValue: "Reception Location",
      value: "",
      id: "receptionLocation",
      group: "The wedding",
      wide: true,
      hint: "If different than ceremony location",
      required: false,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "",
    },
    {
      displayValue: "Overall budget",
      value: "",
      id: "overallBudget",
      group: "Budget",
      hint: "",
      required: false,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "",
    },
    {
      displayValue: "Estimated floral budget",
      value: "",
      id: "floralBudget",
      group: "Budget",
      hint: "(10% - 20% is suggested depending floral style)",
      required: true,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "Please provide an estimated floral budget.",
    },
    {
      displayValue: "When would you like to schedule a consultation?",
      value: "",
      id: "consultationDate",
      group: "A few more details",
      wide: true,
      hint: "",
      required: true,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid:
        "Please provide when you would like to schedule a consultation.",
    },
    {
      displayValue: "Do you have a Pinterest board with your wedding ideas?",
      value: "",
      id: "pinterestBoard",
      group: "A few more details",
      wide: true,
      hint: "Please share private boards with bloom@jmfloralartstudio.com",
      required: false,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "",
    },
    {
      displayValue: "How did you hear about us?",
      value: "",
      id: "referral",
      group: "A few more details",
      wide: true,
      hint: "(Referral, social media, venue, search, etc.)",
      required: false,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "",
    },
  ],
  questionsSecondary: [
    {
      displayValue: "How would you like your wedding day to feel?",
      value: "",
      id: "feeling",
      wide: true,
      hint: "",
      required: false,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "",
    },
    {
      displayValue:
        "Describe you color palette, style, and any important details you would like to share",
      value: "",
      id: "importantDetails",
      wide: true,
      hint: "",
      required: false,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "",
    },
    {
      displayValue: "What is the most important part of your wedding day?",
      value: "",
      id: "weddingDayHighlight",
      wide: true,
      hint: "",
      required: false,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "",
    },
    {
      displayValue:
        "Any additional questions or details you would like to share?",
      value: "",
      id: "additionalDetails",
      wide: true,
      hint: "",
      required: false,
      type: "string",
      placeholder: "",
      invalid: false,
      feedbackInvalid: "",
    },
  ],
  secondaryPrompt: "Any additional information you want to provide?",
};
